import {Slider} from "antd";
import React, {useEffect, useState} from "react";
import {withTranslation} from "react-i18next";
import "./SliderV.scss"

function SliderV(props) {
    const [granularity, setGranularity] = useState(0.5);
    const defaultValue = (props.value === null || props.value === 0) ? 5.5 : props.value

    useEffect(()=> {
        if(defaultValue===5.5) {
            setGranularity(0.5)
        }
    },[defaultValue])

    const onChangeSlider = (val) => {
        setGranularity(1);
        props.onChange(Math.round(val));
    }

    const marks = {
        1: '1',
        2: '2',
        3: '3',
        4: '4',
        5: '5',
        6: '6',
        7: '7',
        8: '8',
        9: '9',
        10: '10',
    };

    const pos = [
            0,1,
    ]
    return (
        <>
            {/* ToDo : Poner un valor por defecto fuera de rango para que sea pueda clicar cuando cargue la pagina el numero 1
                    Documentacion por si te sirve de ayuda: https://ant.design/components/slider/
            */}
            <div className={"custom-slider"}>
                <div className={`backColor transparent`}
                     style={{ width: `${props.value > 0 ? (100-((props.value-1)*11)) : 100}%`}}>
                </div>
                <div className={"border"}></div>
                <Slider
                    min={1}
                    style={{position: "absolute"}}
                    step={granularity}
                    handleStyle={{
                        top: -10,
                        width: 35,
                        height: 35,
                        border: "2px solid #20388F"
                    }}
                    disabled={props.disabled}
                    dots={props.dots}
                    marks={marks}
                    value={defaultValue}
                    style={{top: 6, zIndex: 1}}
                    defaultValue={defaultValue}
                    tooltip={{open: false}}
                    onChange={onChangeSlider}
                    max={10}/>
            </div>
        </>)
}

export default withTranslation()(SliderV);
